import {useContext, useEffect} from "react";
import {ConfiguratorContext} from "../../../context";
import {useIntl} from "react-intl";
import {useQuoteContext} from "../../../contexts/QuoteContext";
import {useAsyncState} from "../../../hook/useAsyncState";
import {EpicorSyncStatus, SyncStatus} from "../../../api/models";
import {Alert, notification} from "antd";

const AlertEpicorSyncFailure = ( ) => {

  const configurator = useContext(ConfiguratorContext);
  const intl = useIntl();

  const {quote} = useQuoteContext();

  const [epicorSyncStatus, epicorSyncStatusAsync] = useAsyncState<SyncStatus>();

  useEffect(() => {
    if ( quote ) {
      loadEpicorSyncStatus(quote?.quoteId);
    }

  }, [quote]);

  const isAdminOrEngineering = configurator.isAdmin() || configurator.isEngineering();

  const loadEpicorSyncStatus = async (quoteId:string | undefined) : Promise<SyncStatus | undefined> => {
    if (!(configurator.isAdmin() || configurator.isEngineering())) return;
    if ( !quoteId ) return;

    epicorSyncStatusAsync.setLoading()

    try {
      const resp = await configurator.api.epicorSyncStatus({
        page: 0, size: 1, filter: quoteId
      });
      const syncStatus = resp.data.content?.[0];
      epicorSyncStatusAsync.setDone(syncStatus)
      return syncStatus;
    }
    catch(e: any) {
      const errorMsg = intl.formatMessage({ id: e.response?.data.message || e.message });
      notification.error( { message: "Failed to load epicor sync status. " + errorMsg });
      epicorSyncStatusAsync.setFail(e.message);
    }

    return;
  }



  if (!isAdminOrEngineering) return <></>;

  return <>

    {(epicorSyncStatus?.erpSyncStatus == EpicorSyncStatus.FAILURE ) &&
        <Alert type="error"
               closable={true}
               message={<>
                 <span>The export to epicor has failed.</span>
                 {!!epicorSyncStatus.erpSyncMessage?.length && <>
                   &nbsp;&nbsp;<span>{epicorSyncStatus?.erpSyncMessage}.</span>
                 </>}
               </>}
        />
    }

    {(epicorSyncStatus?.erpSyncStatus == EpicorSyncStatus.PENDING ) &&
        <Alert type="error" message="The export to epicor is pending." closable={true} />
    }
  </>;

}

export default AlertEpicorSyncFailure;
